var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.0-Help-Center",
    transform: "translate(-395.000000, -612.000000)",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(165.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.832501,18.1342182 C197.626404,18.3658545 197.321727,18.5 196.999988,18.5 C196.67825,18.5 196.373573,18.3658545 196.167476,18.1339636 L190.751002,12.0248727 C190.368057,11.5924 190.430347,10.9499273 190.889664,10.59 C191.350876,10.2300727 192.032269,10.2886182 192.416297,10.7203273 L195.916694,14.6690909 L195.916694,5.51818182 C195.916694,4.95538182 196.401197,4.5 196.999988,4.5 C197.59878,4.5 198.083283,4.95538182 198.083283,5.51818182 L198.083283,14.6690909 L201.583951,10.7205818 C201.966895,10.2891273 202.649371,10.2303273 203.110584,10.5902545 C203.56963,10.9501818 203.63192,11.5924 203.248975,12.0251273 L197.832501,18.1342182 Z",
    id: "Sort-Alphabet-Ascending-path-Copy-6",
    transform: "translate(197.000000, 11.500000) rotate(-90.000000) translate(-197.000000, -11.500000) "
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowRight.de700522e2e2e1bb9cacb9fb9accfe66.svg";